// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__iGyR5","info":"Note_info__-CGnO","note":"Note_note__2DSvt","actions":"Note_actions__1PZ57"};